module.exports = __webpack_public_path__ + "static/winlogo_large-a82318ecc1b9293b8b1b63a12525c428.jpg";